import * as tslib_1 from "tslib";
import { Observable } from "rxjs";
import { RestServiceConstants } from "../../constants/rest-service.constants";
import { RestClient } from "../rest/client/rest.client";
import { ResponseBody } from "../rest/decorators/response-body.decorator";
import { Response } from "../rest/decorators/response.decorator";
import { RequestBody, Query } from "../rest/request/params";
import { Headers } from "../rest/decorators/headers.decorator";
import { DELETE, GET, POST, PUT } from "../rest/request/methods";
import { StringUtil } from "../../utils/string.util";
import { AppConfigUtil } from "../../utils/app-config.util";
import { HttpResponse } from "@angular/common/http";
import { USERConstants } from "src/app/constants/user.constants";
import { ContactInfo, Credentials, EmailAddress, Password } from "src/app/models/user/models";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class USERDataService extends RestClient {
    createAccount(request) {
        return;
    }
    createAccountResponse(sessionGUID, request) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(USERConstants.USER_ACCOUNT, sessionGUID));
        return this.createAccount(request);
    }
    login(request) {
        return;
    }
    callLoginApi(sessionGUID, request) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(USERConstants.LOG_IN, sessionGUID));
        return this.login(request);
    }
    changePassword(request) {
        return;
    }
    callChangePassswordApi(sessionGUID, megUserGUID, request) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(USERConstants.PASSWORD, sessionGUID, megUserGUID));
        return this.changePassword(request);
    }
    changeEmail(request) {
        return;
    }
    callChangeEmailAddressApi(sessionGUID, megUserGUID, request) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(USERConstants.EMAILADDRESS, sessionGUID, megUserGUID));
        return this.changeEmail(request);
    }
    notificationSettings(request) {
        return;
    }
    callNotificationsApi(sessionGUID, megUserGUID, request) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(USERConstants.NOTIFICATION_SETTINGS, sessionGUID, megUserGUID));
        return this.notificationSettings(request);
    }
    contactInfo(request) {
        return;
    }
    callContactInfoApi(sessionGUID, megUserGUID, request) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(USERConstants.CONTACT_INFO, sessionGUID, megUserGUID));
        return this.contactInfo(request);
    }
    registrations(megUserGUID, pageSize) {
        return;
    }
    getRegistraions(selectedAgencyId, sessionID, megUserGUID, pageSize) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(USERConstants.REGISTRATIONS, selectedAgencyId, sessionID));
        return this.registrations(megUserGUID, pageSize);
    }
    paymentDevice() {
        return;
    }
    getPaymentDevices(selectedAgencyId, sessionID) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(USERConstants.GETPAYMENTDEVICE, selectedAgencyId, sessionID));
        return this.paymentDevice();
    }
    deletePaymentDevice() {
        return;
    }
    deletePaymentDeviceCall(sessionID, megUserGUID, fundingToken) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(USERConstants.PAYMENT_DEVICE, sessionID, megUserGUID, fundingToken));
        return this.deletePaymentDevice();
    }
    editPaymentDevice(request) {
        return;
    }
    editPaymentDeviceCall(sessionID, megUserGUID, fundingToken, shortName) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(USERConstants.PAYMENT_DEVICE, sessionID, megUserGUID, fundingToken));
        return this.editPaymentDevice({ shortName: shortName });
    }
    billingAccount() {
        return;
    }
    deleteBillingAccount(sessionID, megUserGUID, billingAccountID) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(USERConstants.BILLING_ACCOUNT, sessionID, megUserGUID, billingAccountID));
        return this.billingAccount();
    }
    addRegistartion(request, optForReminder) {
        return;
    }
    addBillingAccount(sessionID, megUserGUID, request, optForReminder) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(USERConstants.ADD_BILLING_ACCOUNT, sessionID, megUserGUID));
        return this.addRegistartion(request, optForReminder);
    }
    logout() {
        return;
    }
    callLogoutApi(sessionGUID, megUserGUID) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(USERConstants.LOG_OUT, sessionGUID, megUserGUID));
        return this.logout();
    }
    resetPassword() {
        return;
    }
    callResetPasswordApi(sessionGUID, emailAddress) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(USERConstants.RESET_PASSWORD, sessionGUID, emailAddress));
        return this.resetPassword();
    }
    accountCancellationApi() {
        return;
    }
    accountCancellation(sessionGUID, token) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(USERConstants.ACCOUNT_CANCELLATION, sessionGUID, token));
        return this.accountCancellationApi();
    }
    accountCancellationconfirmedApi() {
        return;
    }
    accountCancellationconfirmed(sessionGUID, confirmed) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(USERConstants.ACCOUNT_CANCELLATION_CONFIRMED, sessionGUID, confirmed));
        return this.accountCancellationconfirmedApi();
    }
}
USERDataService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function USERDataService_Factory() { return new USERDataService(i0.ɵɵinject(i1.HttpClient)); }, token: USERDataService, providedIn: "root" });
tslib_1.__decorate([
    Headers({
        Accept: RestServiceConstants.APPLICATION_JSON,
        "content-type": RestServiceConstants.APPLICATION_JSON
    }),
    POST(),
    ResponseBody(),
    tslib_1.__param(0, RequestBody),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", Observable)
], USERDataService.prototype, "createAccount", null);
tslib_1.__decorate([
    POST(),
    ResponseBody(),
    tslib_1.__param(0, RequestBody),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", Observable)
], USERDataService.prototype, "login", null);
tslib_1.__decorate([
    PUT(),
    ResponseBody(),
    tslib_1.__param(0, RequestBody),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", Observable)
], USERDataService.prototype, "changePassword", null);
tslib_1.__decorate([
    PUT(),
    ResponseBody(),
    tslib_1.__param(0, RequestBody),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", Observable)
], USERDataService.prototype, "changeEmail", null);
tslib_1.__decorate([
    PUT(),
    ResponseBody(),
    tslib_1.__param(0, RequestBody),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", Observable)
], USERDataService.prototype, "notificationSettings", null);
tslib_1.__decorate([
    PUT(),
    ResponseBody(),
    tslib_1.__param(0, RequestBody),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", Observable)
], USERDataService.prototype, "contactInfo", null);
tslib_1.__decorate([
    GET(),
    ResponseBody(),
    tslib_1.__param(0, Query("megUserGUID")),
    tslib_1.__param(1, Query("pageSize")),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, Number]),
    tslib_1.__metadata("design:returntype", Observable)
], USERDataService.prototype, "registrations", null);
tslib_1.__decorate([
    GET(),
    ResponseBody(),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", Observable)
], USERDataService.prototype, "paymentDevice", null);
tslib_1.__decorate([
    DELETE(),
    ResponseBody(),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", Observable)
], USERDataService.prototype, "deletePaymentDevice", null);
tslib_1.__decorate([
    PUT(),
    ResponseBody(),
    tslib_1.__param(0, RequestBody),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", Observable)
], USERDataService.prototype, "editPaymentDevice", null);
tslib_1.__decorate([
    DELETE(),
    ResponseBody(),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", Observable)
], USERDataService.prototype, "billingAccount", null);
tslib_1.__decorate([
    POST(),
    ResponseBody(),
    tslib_1.__param(0, RequestBody),
    tslib_1.__param(1, Query("OptForReminder")),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, String]),
    tslib_1.__metadata("design:returntype", Observable)
], USERDataService.prototype, "addRegistartion", null);
tslib_1.__decorate([
    POST(),
    ResponseBody(),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", Observable)
], USERDataService.prototype, "logout", null);
tslib_1.__decorate([
    POST(),
    ResponseBody(),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", Observable)
], USERDataService.prototype, "resetPassword", null);
tslib_1.__decorate([
    POST(),
    Response(),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", Observable)
], USERDataService.prototype, "accountCancellationApi", null);
tslib_1.__decorate([
    PUT(),
    Response(),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", Observable)
], USERDataService.prototype, "accountCancellationconfirmedApi", null);
